"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourseRatesForDate = void 0;
const dayjs = require("dayjs");
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
dayjs.extend(isSameOrBefore);
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isSameOrAfter);
const cloneObject_1 = require("../cloneObject");
const getCourseRatesForDate = (date, number_of_golfers, rates, closure, public_holiday = false) => {
    const rates_obj = (0, cloneObject_1.cloneObject)(rates);
    let is_closed_permanently = false;
    let is_closed_until_further_notice = false;
    let is_course_closed_today = false;
    let closure_end_date = null;
    let has_future_rates = false;
    let has_current_or_future_rates = false;
    let has_current_rates = false;
    let filtered_rates = (0, cloneObject_1.cloneObject)(rates);
    // get the current closure for the date in the closures array.  if there is more than one get the first one
    if (closure) {
        if (closure.reason === "CLOSED_PERMANENTLY") {
            is_closed_permanently = true;
        }
        if (closure.reason === "CLOSED_FURTHER_NOTICE") {
            is_closed_until_further_notice = true;
        }
        if (closure.end_date) {
            closure_end_date = closure.end_date;
        }
        // We have a closure so therefore the course is closed today
        is_course_closed_today = true;
    }
    // Find out if there are any future rates
    has_current_or_future_rates = rates.some((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(rate.start_date).isAfter(dayjs(date)))
            return true;
        if (dayjs(date).isSameOrAfter(dayjs(rate.start_date)) &&
            dayjs(date).isSameOrBefore(dayjs(rate.end_date)))
            return true;
        return false;
    });
    // Find out if there are any future rates
    has_future_rates = rates.some((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(rate.start_date).isAfter(dayjs(date)))
            return true;
        return false;
    });
    // // Find out if there are any rates at all
    // if (rates.length > 0) {
    //   has_had_rates = true;
    // }
    // if the course is closed permanently, return CLOSED_PERMANENTLY
    if (is_closed_permanently) {
        return {
            rates: [],
            closure: true,
            message: "CLOSED_PERMANENTLY",
        };
    }
    // if the course is closed until further notice
    if (is_closed_until_further_notice) {
        const obj = {
            rates: [],
            closure: true,
            message: "",
        };
        // if there is no end date, return CLOSED_FURTHER_NOTICE_NO_END_DATE
        if (!closure_end_date) {
            return {
                ...obj,
                message: "CLOSED_FURTHER_NOTICE_NO_END_DATE",
            };
        }
        // if there are future rates, return CLOSED_FURTHER_NOTICE_WITH_END_DATE_WITH_RATES
        if (has_current_or_future_rates) {
            return {
                ...obj,
                message: "CLOSED_FURTHER_NOTICE_WITH_END_DATE_WITH_RATES",
            };
        }
        // if there are no future rates, return CLOSED_FURTHER_NOTICE_WITH_END_DATE_WITHOUT_RATES
        return {
            ...obj,
            message: "CLOSED_FURTHER_NOTICE_WITH_END_DATE_WITHOUT_RATES",
        };
    }
    // if there are no rates, return NO_RATES_EVER
    if (rates_obj.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_RATES_EVER",
        };
    }
    // filter out the historical rates
    filtered_rates = filtered_rates.filter((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(date).isAfter(dayjs(rate.end_date)))
            return false;
        return true;
    });
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_CURRENT_RATES",
        };
    }
    // does the date fall between the start and end date of a rate
    has_current_rates = filtered_rates.some((rate) => {
        // does the date fall between the start and end dates (inclusive) of the rate?
        if (dayjs(date).isSameOrAfter(dayjs(rate.start_date)) &&
            dayjs(date).isSameOrBefore(dayjs(rate.end_date)))
            return true;
        return false;
    });
    if (!has_current_rates && has_future_rates) {
        return {
            rates: [],
            closure: false,
            message: "NO_CURRENT_RATES_HAS_FUTURE_RATES",
        };
    }
    // IS THE COURSE CLOSED FOR THE DAY (NOT BECAUSE OF STANDARD CLOSURE OR RATE UNAVAILABILITY ON THIS DAY)
    if (is_course_closed_today) {
        // get the current closure for the date in the closures array.  if there is more than one get the first one
        let closure_for_date = null;
        if (closure) {
            closure_for_date = closure;
        }
        // get start / end times for closures (e.g partial day closures)
        let start_time = null;
        let end_time = null;
        if (closure_for_date) {
            start_time = closure_for_date.start_time;
            end_time = closure_for_date.end_time;
        }
        filtered_rates = filtered_rates.filter((rate) => {
            // if there's no closure times, keep all rates
            if (!start_time || !end_time)
                return true;
            // if rate has no time constraints, it's affected by any closure
            if (!rate.earliest_time || !rate.latest_time)
                return false;
            const closure_start = dayjs(start_time, "HH:mm");
            const closure_end = dayjs(end_time, "HH:mm");
            const rate_start = dayjs(rate.earliest_time, "HH:mm");
            const rate_end = dayjs(rate.latest_time, "HH:mm");
            // Keep rate if it's completely before the closure
            if (rate_end.isBefore(closure_start))
                return true;
            // Keep rate if it's completely after the closure
            if (rate_start.isAfter(closure_end))
                return true;
            // Filter out rates that overlap with closure
            return false;
        });
        if (filtered_rates.length === 0) {
            return {
                rates: [],
                closure: true,
                message: "CLOSURE_TODAY",
            };
        }
    }
    //
    // Check for DAYS_OF_OPERATION_CLOSURE
    filtered_rates = filtered_rates.filter((rate) => {
        // filter out the rates where the course days of operation do not include the day of the date
        const day = dayjs(date).format("ddd");
        if (!day)
            return false;
        const key = day.toLowerCase();
        if (!rate.days_of_operation[key]) {
            return false;
        }
        return true;
    });
    // If after this first level filter that there are no rates, return DAYS_OF_OPERATION_CLOSURE
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "DAYS_OF_OPERATION_CLOSURE",
        };
    }
    // CHECK RATES ARE AVAILABLE FOR THE CURRENT DATE (NOT A CLOSURE)
    filtered_rates = filtered_rates.filter((rate) => {
        // filter out the rates where the course days of operation do not include the day of the date
        const day = dayjs(date).format("ddd");
        if (!day)
            return false;
        const key = public_holiday ? "hol" : day.toLowerCase();
        if (!rate.availability_days[key]) {
            return false;
        }
        return true;
    });
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "RATE_AVAILABLE_DAYS_CLOSURE",
        };
    }
    const has_valid_number_of_golfers = filtered_rates.some((rate) => {
        if (number_of_golfers % rate?.multiples !== 0) {
            return false;
        }
        if (number_of_golfers >= rate.min_pax) {
            return true;
        }
        return false;
    });
    // ARE THERE ANY RATES WHERE THE NUMBER OF GOLFERS IS VALID
    if (has_valid_number_of_golfers) {
        const has_valid_number_of_golfers_for_date = filtered_rates.some((rate) => {
            if (number_of_golfers % rate?.multiples === 0 &&
                number_of_golfers >= rate.min_pax &&
                dayjs(date).isSameOrAfter(dayjs(rate.start_date)) &&
                dayjs(date).isSameOrBefore(dayjs(rate.end_date))) {
                return true;
            }
            return false;
        });
        const has_valid_number_of_golfers_in_future = filtered_rates.some((rate) => {
            if (number_of_golfers % rate?.multiples === 0 &&
                number_of_golfers >= rate.min_pax &&
                dayjs(date).isBefore(dayjs(rate.start_date))) {
                return true;
            }
            return false;
        });
        if (!has_valid_number_of_golfers_for_date &&
            has_valid_number_of_golfers_in_future) {
            return {
                rates: [],
                closure: false,
                message: "INVALID_NUMBER_OF_GOLFERS_TODAY",
            };
        }
        filtered_rates = filtered_rates.filter((rate) => {
            if (number_of_golfers % rate?.multiples !== 0) {
                return false;
            }
            if (number_of_golfers < rate.min_pax) {
                return false;
            }
            return true;
        });
    }
    else {
        return {
            rates: [],
            closure: false,
            message: "INVALID_NUMBER_OF_GOLFERS_EVER",
        };
    }
    // does the date fall between the start and end date of the rate?
    filtered_rates = filtered_rates.filter((rate) => {
        if (dayjs(date).isBefore(dayjs(rate.start_date)))
            return false;
        if (dayjs(date).isAfter(dayjs(rate.end_date)))
            return false;
        return true;
    });
    // Group the rates
    const grouped_rates = filtered_rates.reduce((r, a) => {
        r[`${a.product_sku}_${a.product_type_name.en}_${a.course_hole_combination}_${a.min_pax}_${a.max_pax}_${a.multiples}`] = [
            ...(r[`${a.product_sku}_${a.product_type_name.en}_${a.course_hole_combination}_${a.min_pax}_${a.max_pax}_${a.multiples}`] || []),
            a,
        ];
        return r;
    }, {});
    // Sort the rates
    const sorted_rates = Object.keys(grouped_rates)
        .map((key) => {
        // group and sort them to get the cheapest rate
        return grouped_rates[key].sort((a, b) => Number(a.sell_price) - Number(b.sell_price))[0];
    })
        .sort((a, b) => Number(a.sell_price) - Number(b.sell_price));
    if (sorted_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_RATES",
        };
    }
    return {
        rates: sorted_rates,
        closure: false,
        message: "RATES_FOUND",
    };
};
exports.getCourseRatesForDate = getCourseRatesForDate;
